module.exports = __webpack_public_path__ + "static/media/product-one.2625c13e.svg";